import styled from 'styled-components';

import { Badge } from '@xemplo/badge';
import { Colour, TextEllipsis } from '@xemplo/style-constants';

export const ChipsWrapper = styled.div`
  display: flex;
  position: relative;
  flex-grow: 1;
  min-width: 0;
`;

export const ChipGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1 1 auto;
  min-width: 0;
  transition: visibility 0.1s ease-in-out;

  &.hidden-chip {
    visibility: hidden;
  }
`;

export const SelectedText = styled.span`
  ${TextEllipsis};
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.1s ease-in-out;

  &.visible-chip {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const Chip = styled(Badge)`
  &.readOnly,
  &.disabled {
    background-color: ${Colour.Gray[200]};
    color: ${Colour.Light[100]};
  }

  &:not(.readOnly, .disabled) {
    > svg {
      cursor: pointer;
    }
  }
`;
